window.UniqueNameForm = new function()
{
    this.vars = {
      name_timer: 0,
      name_timer_interval: false,
      token: jQuery('meta[name="csrf-token"]').attr('content'),
      name_max_length: jQuery('form.unique-name-form input[name="name"]').data('character-limit')
    };

    this.init = function() {
        jQuery('body').on('change', 'form.unique-name-form input[name="name"]', function(event) {
            if(!jQuery(this).val()) {
                var form        = jQuery(this).closest('form.unique-name-form');
                var entity_type = jQuery(form).find('.entity-type').val();

                var community_id = '';
                if(jQuery(form).find('input[name="community_id"]').length) {
                    community_id = jQuery(form).find('input[name="community_id"]').val();
                }

                var topic_id = '';
                if(jQuery(form).find('input[name="topic_id"]').length) {
                    topic_id = jQuery(form).find('input[name="topic_id"]').val();
                }

                var val  = jQuery(this).val();
                var name = val;
                name     = name.substring(0, UniqueNameForm.vars.name_max_length);
                jQuery(this).val(name);
                UniqueNameForm.nameAvailable(name, entity_type, community_id, topic_id, form);
            }
        });

        jQuery('body').on('keyup', 'form.unique-name-form input[name="name"]', function(event) {
            var form        = jQuery(this).closest('form.unique-name-form');
            var entity_type = jQuery(form).find('.entity-type').val();

            var community_id = '';
            if(jQuery(form).find('input[name="community_id"]').length) {
                community_id = jQuery(form).find('input[name="community_id"]').val();
            }

            var topic_id = '';
            if(jQuery(form).find('input[name="topic_id"]').length) {
                topic_id = jQuery(form).find('input[name="topic_id"]').val();
            }

            var that                       = this;
            UniqueNameForm.vars.name_timer = 0;

            if(UniqueNameForm.vars.name_timer_interval) {
                clearInterval(UniqueNameForm.vars.name_timer_interval);
                UniqueNameForm.vars.name_timer_interval = false;
            }

            if(!UniqueNameForm.vars.name_timer_interval) {
                UniqueNameForm.vars.name_timer_interval = setInterval(function() { 
                    UniqueNameForm.vars.name_timer++;

                    //Throttle AJAX request to 1 interval pass of no typing from the user (300 miliseconds)
                    if(UniqueNameForm.vars.name_timer >= 1) {
                        clearInterval(UniqueNameForm.vars.name_timer_interval);
                        UniqueNameForm.vars.name_timer_interval = false;
                        UniqueNameForm.vars.name_timer          = 0;

                        var val  = jQuery(that).val();
                        var name = val;
                        name     = name.substring(0, UniqueNameForm.vars.name_max_length);
                        jQuery(that).val(name);
                        UniqueNameForm.nameAvailable(name, entity_type, community_id, topic_id, form);
                    }
                }, 300);
            }
        });
    };

    /**
     * Check if name is available
     * 
     * @param string name
     * @param string entity_type - type of entity to check data on (encrypted)
     * @param string community_id
     * @param string topic_id
     * @param obj form
     */
    this.nameAvailable = function(name, entity_type, community_id, topic_id, form) {
        $.ajax({
            url: '/uniquenameform/nameavailable',
            type: 'POST',
            data: {
                name: name,
                entity_type: entity_type,
                community_id: community_id,
                topic_id: topic_id,
                _token: UniqueNameForm.vars.token
            },
            showloader: true,
            success: function(response) { 
                if(response == 0) {
                    jQuery(form).find('.name-availability').html('<div class="red">Name is not available</div>');
                    jQuery(form).find('button').prop('disabled', true);
                } else {
                    jQuery(form).find('.name-availability').html('<div class="green">Name is available!</div>');
                    jQuery(form).find('button').prop('disabled', false);
                }
            }
        });
    };
}

jQuery(document).ready(function($) {
    UniqueNameForm.init();
});
